// extracted by mini-css-extract-plugin
export default {"smTd":"WinnersList_smTd__WQXOS","priceTd":"WinnersList_priceTd__nwEg8"};